var map = {
	"./aisTh/images/favicon.ico": 197,
	"./bnpParibasFR/images/favicon.ico": 198,
	"./bolttech/images/favicon.ico": 199,
	"./fwdGI/images/favicon.ico": 200,
	"./fwdLIFE/images/favicon.ico": 201,
	"./homecreditPh/images/favicon.ico": 202,
	"./hyundaiCard/images/favicon.ico": 203,
	"./lguplus/images/favicon.ico": 204,
	"./linefrank/images/favicon.ico": 205,
	"./orangeFR/images/favicon.ico": 206,
	"./paymayaPh/images/favicon.ico": 207,
	"./reconnects/images/favicon.ico": 208,
	"./threeIe/images/favicon.ico": 209,
	"./threehk/images/favicon.ico": 210,
	"./wind/images/favicon.ico": 211,
	"./windtreIT/images/favicon.ico": 212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 196;